<template>
  <div class="scroll-container" ref="scrollContainer"  style="overflow-y:auto">
    <div class="scroll-wrapper" ref="scrollWrapper" :style="{top: top + 'px'}">
      <slot></slot>
    </div>
  </div>
</template>

<script>
const delta = 15

export default {
  name: 'scrollBar',
  data() {
    return {
      top: 0
    }
  },
  methods: {
    handleScroll(e) {
      const eventDelta = e.wheelDelta || -e.deltaY * 3
      const $container = this.$refs.scrollContainer
      const $containerHeight = $container.offsetHeight
      const $wrapper = this.$refs.scrollWrapper
      const $wrapperHeight = $wrapper.offsetHeight
      if (eventDelta > 0) {
        this.top = Math.min(0, this.top + eventDelta)
      } else {
        if ($containerHeight - delta < $wrapperHeight) {
          if (this.top < -($wrapperHeight - $containerHeight + delta)) {
            this.top = this.top
          } else {
            this.top = Math.max(this.top + eventDelta, $containerHeight - $wrapperHeight - delta)
          }
        } else {
          this.top = 0
        }
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import '../../styles/variables.scss';

.scroll-container {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: $menuBg;
  .scroll-wrapper {
    position: absolute;
     width: 100%!important;
  }
}

.scroll-container::-webkit-scrollbar {
    width: 15px;
    background: rgba(0, 0, 0, 0);
}
.scroll-container::-webkit-scrollbar-track {
    background-color: rgba(0, 0, 0, 0.05);
}
.scroll-container::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background: rgba(110, 116, 204, 0.15);
}
.scroll-container:hover::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background: rgba(110, 116, 204, 0.7);
}
.scroll-container::-webkit-scrollbar-thumb:hover {
    background: rgba(110, 116, 204, 1) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ScrollBar/index.vue